import React, { useContext, useEffect, useState, useRef } from "react"; // eslint-disable-line no-unused-vars
import { makeStyles } from "@material-ui/core/styles";
import { State } from "../../store/state";
import {
  Typography,
  TextField,
  Grid,
  Paper,
  IconButton,
  Stepper,
  Step,
  StepButton,
  StepContent,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormControlLabel,
  Checkbox,
  StepLabel,
  InputLabel,
  Select,
  FormControl,
  FormHelperText,
  Link,
} from "@material-ui/core";
import { Info as InfoIcon } from "@material-ui/icons";
import * as consts from "../../consts";
import { useAuth0 } from "@auth0/auth0-react";
import {
  emailIssues,
  firstNameIssues,
  lastNameIssues,
  addressIssues,
  cityIssues,
  stateIssues,
  zipIssues,
  creditCardNumberIssues,
  creditCardCodeIssues,
  creditCardExpirationIssues,
  validateBilling,
  validateBillingAddress,
  validateBillingCreditCard,
} from "../../store/validators";
import {
  setBilling,
  setOptIn,
  setBusinessUse,
  processCart,
  setBusy,
  getQuoteDetails,
  setQuoteDetails,
  handleError,
} from "../../store/actions";
import InputMask from "react-input-mask";

export default function Payment({ quote }) {
  const useStyles = makeStyles((theme) => ({
    commands: { textAlign: "right", paddingRight: "8px" },
    stepper: {
      [theme.breakpoints.down("md")]: {
        padding: "0px",
      },
    },
    stepContent: {
      [theme.breakpoints.down("md")]: {
        padding: "10px",
      },
    },
    stepLink: {
      "&:focus": {
        background: "none",
        boxShadow: "none",
      },
      "&:active": {
        background: "none",
        boxShadow: "none",
      },
      "&:hover": {
        background: "none",
        boxShadow: "none",
        "& svg": {
          color: "#272643",
        },
      },
    },
    stepButtonPrimary: {
      margin: theme.spacing(1),
      "&:hover": { color: "#ffffff" },
    },
    stepButtonSecondary: {
      margin: theme.spacing(1),
      "&:hover": { color: "#272643" },
    },
    paymentOptions: {
      textAlign: "right",
      "& img": {
        width: "30px",
        verticalAlign: "middle",
        display: "inline-block",
      },
    },
    paymentGroup: {
      width: "100%",
    },
    paymentInput: {
      border: "1px solid #000000",
      width: "100%",
    },
    input: {
      "& input": {
        height: "100%",
        padding: "18.5px 14px",
        border: "0",
        background: "none",
      },
    },
    singleLine: {
      whiteSpace: "nowrap",
    },
    iconButton: {
      "&:focus": { color: "inherit" },
      "&:hover": { color: "inherit" },
    },
  }));
  const classes = useStyles();
  const { state, dispatch } = useContext(State);
  const {
    isLoading,
    isAuthenticated,
    user,
    loginWithRedirect,
    loginWithPopup,
    getAccessTokenSilently,
  } = useAuth0();
  const [ga4Enabled, setGA4Enabled] = useState(false);
  const [blurList, setBlurList] = useState([]);
  const [showCheckout, setShowCheckout] = useState(false);
  const [expandBusinessUseInfo, setExpandBusinessUseInfo] = useState(false);
  const [activeStep, setActiveStep] = useState(isAuthenticated ? 1 : 0);
  const [steps, setSteps] = useState([
    {
      id: "login",
      label: "Login",
      complete: false,
      error: false,
    },
    {
      id: "address",
      label: "Billing Address",
      complete: false,
      error: false,
    },
    {
      id: "payment",
      label: "Payment Information",
      complete: false,
      error: false,
    },
    {
      id: "confirm",
      label: "Confirm",
      complete: false,
      error: false,
    },
  ]);

  useEffect(() => {
    try {
      gtag("event", "AdBlockerTest", {
        event_callback: function () {
          setGA4Enabled(true);
        },
      });
    } catch (error) {}
  }, []);

  const acceptData = useRef(null);
  const onHandshake = () => {
    if (acceptData.loading) {
      acceptData.loading = false;
      window.removeEventListener("handshake", onHandshake);
      setTimeout(() => {
        Accept.dispatchData(acceptData.current, responseHandler);
      }, 1000);
    }
  };
  const responseHandler = (response) => {
    if (response.messages.resultCode != "Error") {
      let nonce = response.opaqueData.dataValue;

      let cardTotal = 0;
      let productionTotal = 0;
      let shippingTotal = 0;
      let orderAdjustments = 0;
      state.orderAdjustments.map((orderAdjustment) => {
        orderAdjustments += orderAdjustment.amount;
      });
      let shippingAdded = false;

      let stmShippingMethod = null;
      let stmshippingHandling = null;

      quote.map((cartItem, cartItemIndex) => {
        switch (cartItem.cardType) {
          case consts.CARD_TYPE_PLASTIC:
            if (
              cartItem.mailOption == consts.PLASTIC_TYPE_ME ||
              cartItem.mailOption == consts.PLASTIC_TYPE_NO_CARRIER
            ) {
              cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
                if (stmShippingMethod && stmshippingHandling) {
                  cardDetail.shipping.method = stmShippingMethod;
                  cardDetail.cardFee.shippingHandling = stmshippingHandling;
                } else {
                  stmShippingMethod = cardDetail.shipping.method;
                  stmshippingHandling = cardDetail.cardFee.shippingHandling;
                }

                cardTotal += cartItem.cardValue;
                if (cardDetail.cardFee) {
                  productionTotal += cardDetail.cardFee.productionFee;
                  if (!shippingAdded && cardDetailIndex == 0) {
                    shippingAdded = true;
                    shippingTotal += cardDetail.cardFee.shippingHandling;
                  }
                }
              });
            } else {
              cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
                cardTotal += cartItem.cardValue;
                if (cardDetail.cardFee) {
                  productionTotal += cardDetail.cardFee.productionFee;
                  shippingTotal += cardDetail.cardFee.shippingHandling;
                }
              });
            }
            break;
          case consts.CARD_TYPE_EMAIL:
            cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
              cardTotal += cartItem.cardValue;
              if (cardDetail.cardFee) {
                productionTotal += cardDetail.cardFee.productionFee;
              }
            });
            break;
          case consts.CARD_TYPE_PRINTER:
            cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
              cardTotal += cartItem.cardValue;
              if (cardDetail.cardFee) {
                productionTotal += cardDetail.cardFee.productionFee;
              }
            });
            break;
        }
      });

      let creditCardFee =
        (cardTotal + productionTotal + shippingTotal + orderAdjustments) * 0.03;

      let total =
        cardTotal +
        productionTotal +
        state.supportTotal +
        shippingTotal +
        creditCardFee +
        orderAdjustments;
      processCart(
        state.transactionID,
        state.optIn,
        state.businessUse,
        quote,
        {
          nonce: nonce,
          firstName: state.billing.firstName,
          lastName: state.billing.lastName,
          businessOrder: state.billing.business,
          company: state.billing.company,
          address: state.billing.address,
          city: state.billing.city,
          state: state.billing.state,
          zip: state.billing.zip,
          paymentType: "CREDIT CARD",
          email: state.billing.email,
        },
        total,
        state.supportTotal,
        creditCardFee,
        state.quoteid,
        state.campaignID,
        state.orderAdjustments,
        getAccessTokenSilently,
        dispatch
      )
        .then((receipt) => {
          if (consts.ENABLE_TRACKING == "true" && ga4Enabled) {
            trackGoogle(receipt);
          } else {
            window.location.href = `/receipt?orderID=${receipt.transactionID}`;
          }
        })
        .catch((error) => {
          setBusy(false, dispatch);
          // let transactionID = error.data.transactionID;
          // setTransactionID(transactionID, dispatch);
        });
    } else {
      setBusy(false, dispatch).then(() => {
        let updatedSteps = [...steps];
        updatedSteps[2] = {
          ...steps[2],
          complete: false,
          error: true,
        };
        setSteps(updatedSteps);
        setActiveStep(2);
        handleError(response, `Unable to process payment`, dispatch);
      });
    }
  };
  const callAccept = (data) => {
    acceptData.current = data;
    acceptData.loading = true;
    window.removeEventListener("handshake", onHandshake);
    window.addEventListener("handshake", onHandshake);
    var scripts = document.head.getElementsByTagName("script");
    for (var i = 0; i < scripts.length; i++) {
      if (scripts[i].getAttribute("src") === consts.AUTHORIZE_SCRIPT) {
        document.head.removeChild(scripts[i]);
        break;
      }
    }
    let script = document.createElement("script");
    script.src = consts.AUTHORIZE_SCRIPT;
    document.head.appendChild(script);
  };
  const submitPayment = () => {
    let userValid = true;
    let addressValid = true;
    let paymentValid = true;
    let inputErrors = [];
    if (!state.billing.email || state.billing.email.length == 0) {
      inputErrors.push({
        input: consts.ERROR_INPUT_BILLING_EMAIL,
        message: "Field is required",
      });
      userValid = false;
    }
    if (!consts.VALIDATION_EMAIL.test(state.billing.email)) {
      inputErrors.push({
        input: consts.ERROR_INPUT_BILLING_EMAIL,
        message: "Not a valid email address",
      });
      userValid = false;
    }
    if (!state.billing.firstName || state.billing.firstName.length == 0) {
      inputErrors.push({
        input: consts.ERROR_INPUT_BILLING_FIRST_NAME,
        message: "Field is required",
      });
      addressValid = false;
    }
    if (!state.billing.lastName || state.billing.lastName.length == 0) {
      inputErrors.push({
        input: consts.ERROR_INPUT_BILLING_LAST_NAME,
        message: "Field is required",
      });
      addressValid = false;
    }
    if (!state.billing.address || state.billing.address.length == 0) {
      inputErrors.push({
        input: consts.ERROR_INPUT_BILLING_ADDRESS,
        message: "Field is required",
      });
      addressValid = false;
    }
    if (!state.billing.city || state.billing.city.length == 0) {
      inputErrors.push({
        input: consts.ERROR_INPUT_BILLING_CITY,
        message: "Field is required",
      });
      addressValid = false;
    }
    if (!state.billing.state || state.billing.state.length == 0) {
      inputErrors.push({
        input: consts.ERROR_INPUT_BILLING_STATE,
        message: "Field is required",
      });
      addressValid = false;
    }
    if (!state.billing.zip || state.billing.zip.length == 0) {
      inputErrors.push({
        input: consts.ERROR_INPUT_BILLING_ZIP,
        message: "Field is required",
      });
      addressValid = false;
    }
    if (!state.billing.cardNumber || state.billing.cardNumber.length < 16) {
      paymentValid = false;
    }
    if (!state.billing.expiration || state.billing.expiration.length < 4) {
      paymentValid = false;
    }
    if (!state.billing.cardCode || state.billing.cardCode.length < 3) {
      paymentValid = false;
    }
    if (!userValid) {
      setBilling({ ...state.billing, inputErrors: inputErrors }, dispatch).then(
        () => {
          setBusy(false, dispatch).then(() => {
            setActiveStep(activeStep - 2);
          });
        }
      );
    } else if (!addressValid) {
      setBilling({ ...state.billing, inputErrors: inputErrors }, dispatch).then(
        () => {
          setBusy(false, dispatch).then(() => {
            setActiveStep(activeStep - 1);
          });
        }
      );
    } else if (paymentValid) {
      let authData = {
        clientKey: consts.AUTHORIZE_CLIENT_KEY,
        apiLoginID: consts.AUTHORIZE_API_LOGIN_ID,
      };
      let splitExpiration = state.billing.expiration.split("/");
      let expirationMonth = splitExpiration[0];
      let expirationYear = splitExpiration[1];
      let cardData = {
        cardNumber: state.billing.cardNumber
          .replace(/-/g, "")
          .replace(/ /g, ""),
        month: expirationMonth,
        year: expirationYear,
        cardCode: state.billing.cardCode.trim(),
        zip: state.billing.zip,
        fullName: state.billing.firstName + " " + state.billing.lastName,
      };
      if (process.env.NODE_ENV === "development") {
        responseHandler({
          messages: { resultCode: "Whatever" },
          opaqueData: { dataValue: "SOMENUMBERANDLETTERCOMBO" },
        });
      } else {
        callAccept({ authData: authData, cardData: cardData });
      }
    }
  };
  let trackGoogle = (receipt) => {
    let analyticsTranProducts = [];
    let analyticsV4TranProducts = [];

    let cardTotal = 0;
    let productionTotal = 0;
    let shippingTotal = 0;
    let productionFee = 0;

    if (receipt) {
      receipt.cartItems.map((cartItem, cartItemIndex) => {
        if (
          cartItem.cardType == consts.CARD_TYPE_PLASTIC &&
          cartItem.mailOption == consts.PLASTIC_TYPE_ME
        ) {
          productionFee + 3.29;
          analyticsTranProducts.push({
            sku: "STM",
            name: "Plastic Card",
            category: "Charity Gift Card Purchase",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          analyticsV4TranProducts.push({
            item_id: "STM",
            item_name: "Plastic Card",
            item_brand: "TisBest",
            item_category: "Charity Gift Card Purchase",
            item_variant: "",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
              if (cartItemIndex == 0 && cardDetailIndex == 0) {
                shippingTotal += cardDetail.cardFee.shippingHandling;
              }
            }
          });
        }
        if (
          cartItem.cardType == consts.CARD_TYPE_PLASTIC &&
          cartItem.mailOption == consts.PLASTIC_TYPE_NO_CARRIER
        ) {
          productionFee + 1.0;
          analyticsTranProducts.push({
            sku: "NC",
            name: "Plastic Card",
            category: "Charity Gift Card Purchase",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          analyticsV4TranProducts.push({
            item_id: "NC",
            item_name: "Plastic Card",
            item_brand: "TisBest",
            item_category: "Charity Gift Card Purchase",
            item_variant: "",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          cartItem.cardDetails.map((cardDetail, cardDetailIndex) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
              if (cartItemIndex == 0 && cardDetailIndex == 0) {
                shippingTotal += cardDetail.cardFee.shippingHandling;
              }
            }
          });
        }
        if (
          cartItem.cardType == consts.CARD_TYPE_PLASTIC &&
          cartItem.mailOption == consts.PLASTIC_TYPE_THEM
        ) {
          productionFee + 3.29;
          analyticsTranProducts.push({
            sku: "STT",
            name: "Plastic Card",
            category: "Charity Gift Card Purchase",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          analyticsV4TranProducts.push({
            item_id: "STT",
            item_name: "Plastic Card",
            item_brand: "TisBest",
            item_category: "Charity Gift Card Purchase",
            item_variant: "",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          cartItem.cardDetails.map((cardDetail) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
              shippingTotal += cardDetail.cardFee.shippingHandling;
            }
          });
        }
        if (
          cartItem.cardType == consts.CARD_TYPE_EMAIL &&
          cartItem.emailOption == consts.EMAIL_TYPE_NOW
        ) {
          analyticsTranProducts.push({
            sku: "ENOW",
            name: "Digital Card",
            category: "Charity Gift Card Purchase",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          analyticsV4TranProducts.push({
            item_id: "ENOW",
            item_name: "Digital Card",
            item_brand: "TisBest",
            item_category: "Charity Gift Card Purchase",
            item_variant: "",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          cartItem.cardDetails.map((cardDetail) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
            }
          });
        }
        if (
          cartItem.cardType == consts.CARD_TYPE_EMAIL &&
          cartItem.emailOption == consts.EMAIL_TYPE_LATER
        ) {
          analyticsTranProducts.push({
            sku: "ELATER",
            name: "Digital Card",
            category: "Charity Gift Card Purchase",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          analyticsV4TranProducts.push({
            item_id: "ELATER",
            item_name: "Digital Card",
            item_brand: "TisBest",
            item_category: "Charity Gift Card Purchase",
            item_variant: "",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          cartItem.cardDetails.map((cardDetail) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
            }
          });
        }
        if (cartItem.cardType == consts.CARD_TYPE_PRINTER) {
          analyticsTranProducts.push({
            sku: "PRINT",
            name: "Printable Card",
            category: "Charity Gift Card Purchase",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          analyticsV4TranProducts.push({
            item_id: "PRINT",
            item_name: "Printable Card",
            item_brand: "TisBest",
            item_category: "Charity Gift Card Purchase",
            item_variant: "",
            price: cartItem.cardValue,
            quantity: cartItem.cardDetails.length,
          });
          cartItem.cardDetails.map((cardDetail) => {
            cardTotal += cartItem.cardValue;
            if (cardDetail.cardFee) {
              productionTotal += cardDetail.cardFee.productionFee;
            }
          });
        }
      });
      analyticsTranProducts.push({
        sku: "SUPPORT",
        name: "TisBest Donation - Checkout",
        category: "TisBest Support",
        price: receipt.supportTotal,
        quantity: receipt.supportTotal > 0 ? 1 : 0,
      });
      analyticsV4TranProducts.push({
        item_id: "SUPPORT",
        item_name: "TisBest Donation - Checkout",
        item_brand: "TisBest",
        item_category: "TisBest Support",
        item_variant: "",
        price: receipt.supportTotal,
        quantity: receipt.supportTotal > 0 ? 1 : 0,
      });
      if (productionFee > 0) {
        analyticsTranProducts.push({
          sku: "PRODUCTION FEE",
          name: "TisBest Production Fee - Checkout",
          category: "TisBest Production Fee",
          price: productionFee,
          quantity: 1,
        });
        analyticsV4TranProducts.push({
          item_id: "PRODUCTION FEE",
          item_name: "TisBest Production Fee - Checkout",
          item_brand: "TisBest",
          item_category: "TisBest Production Fee",
          item_variant: "",
          price: productionFee,
          quantity: 1,
        });
      }
    }
    // prettier-ignore
    // let conversionEvent = {
    //   transactionId: `PRD-${state.businessUse ? "B" : "P"}-${receipt.orderID}`,
    //   transactionAffiliation: "TisBest",
    //   transactionShipping: shippingTotal,
    //   transactionTotal:
    //     cardTotal +
    //     productionTotal +
    //     shippingTotal +
    //     receipt.supportTotal +
    //     productionFee,
    //   transactionProducts: analyticsTranProducts,
    // };
    // window.dataLayer = window.dataLayer || [];
    // dataLayer.push(conversionEvent);
    // dataLayer.push({
    //   event: "transactionComplete",
    //   eventCallback: function () {
    //     window.location.href = `/receipt?orderID=${receipt.transactionID}`;
    //   },
    //   eventTimeout: 2000,
    // });

    let eventParameters = {
      send_to: "G-SJ3Y1X040X",
      transaction_id: `PRD-${state.businessUse ? "B" : "P"}-${receipt.orderID}`,
      affiliation: "TisBest",
      currency: "USD",
      value:
        cardTotal +
        productionTotal +
        shippingTotal +
        receipt.supportTotal +
        productionFee,
      tax: 0,
      shipping: shippingTotal,
      items: analyticsV4TranProducts,
      event_callback: function () {
        window.location.href = `/receipt?orderID=${receipt.transactionID}`;
      },
      event_timeout: 2000,
    };
    gtag("event", "purchase", eventParameters);
  };

  const renderBillingEmailInput = () => {
    let error =
      blurList.indexOf("Email") > -1 ? emailIssues(state.billing.email) : null;
    return (
      <TextField
        autoComplete="billing email"
        className={classes.input}
        required={true}
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        error={error ? true : false}
        helperText={error ? error : ""}
        label="Confirmation Email"
        value={state.billing.email}
        onChange={(event) => {
          setBlurList([...blurList, "Email"]);
          setBilling(
            {
              ...state.billing,
              email: event.target.value,
            },
            dispatch
          );
        }}
      />
    );
  };
  const renderOptInInput = () => {
    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={state.optIn}
            onChange={(event) => {
              setOptIn(event.target.checked, dispatch);
            }}
          />
        }
        label="Keep me informed about TisBest."
      />
    );
  };
  const renderBusinessUseInput = () => {
    return (
      <React.Fragment>
        <FormControlLabel
          control={
            <Checkbox
              checked={state.businessUse}
              onChange={(event) => {
                setBusinessUse(event.target.checked, dispatch);
              }}
            />
          }
          label={
            <span className={classes.singleLine}>
              Order is for business use
              <IconButton
                className={classes.iconButton}
                size="small"
                aria-label="Business use information"
                color="inherit"
                onClick={(event) => {
                  setExpandBusinessUseInfo(!expandBusinessUseInfo);
                }}
              >
                <InfoIcon fontSize="small" />
              </IconButton>
            </span>
          }
        />

        {expandBusinessUseInfo ? (
          <Typography variant="caption" component="div">
            If you check this box our team will know you are using this order
            for business purposes &amp; can provide appropriate support. Email
            any questions to{" "}
            <a href="mailto:businesssales@tisbest.org">
              businesssales@tisbest.org
            </a>
            .
          </Typography>
        ) : null}
      </React.Fragment>
    );
  };
  const renderBillingFirstNameInput = () => {
    let error =
      blurList.indexOf("FirstName") > -1
        ? firstNameIssues(state.billing.firstName)
        : null;
    return (
      <TextField
        autoComplete="billing given-name"
        className={classes.input}
        required={true}
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        error={error ? true : false}
        helperText={error ? error : ""}
        label="First Name"
        value={state.billing.firstName}
        onChange={(event) => {
          setBlurList([...blurList, "FirstName"]);
          setBilling(
            {
              ...state.billing,
              firstName: event.target.value,
            },
            dispatch
          );
        }}
      />
    );
  };
  const renderBillingLastNameInput = () => {
    let error =
      blurList.indexOf("LastName") > -1
        ? lastNameIssues(state.billing.lastName)
        : null;
    return (
      <TextField
        autoComplete="billing family-name"
        className={classes.input}
        required={true}
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        error={error ? true : false}
        helperText={error ? error : ""}
        label="Last Name"
        value={state.billing.lastName}
        onChange={(event) => {
          setBlurList([...blurList, "LastName"]);
          setBilling(
            {
              ...state.billing,
              lastName: event.target.value,
            },
            dispatch
          );
        }}
      />
    );
  };
  const renderBillingCompanyInput = () => {
    return (
      <TextField
        autoComplete="billing company"
        className={classes.input}
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        label="Company"
        value={state.billing.company}
        onChange={(event) => {
          setBilling(
            {
              ...state.billing,
              company: event.target.value,
            },
            dispatch
          );
        }}
      />
    );
  };
  const renderBillingAddressInput = () => {
    let error =
      blurList.indexOf("Address") > -1
        ? addressIssues(state.billing.address)
        : null;
    return (
      <TextField
        autoComplete="billing street-address"
        className={classes.input}
        required={true}
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        error={error ? true : false}
        helperText={error ? error : ""}
        label="Address"
        value={state.billing.address}
        onChange={(event) => {
          setBlurList([...blurList, "Address"]);
          setBilling(
            {
              ...state.billing,
              address: event.target.value,
            },
            dispatch
          );
        }}
      />
    );
  };
  const renderBillingCityInput = () => {
    let error =
      blurList.indexOf("City") > -1 ? cityIssues(state.billing.city) : null;
    return (
      <TextField
        autoComplete="billing address-level2"
        className={classes.input}
        required={true}
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        error={error ? true : false}
        helperText={error ? error : ""}
        label="City"
        value={state.billing.city}
        onChange={(event) => {
          setBlurList([...blurList, "City"]);
          setBilling(
            {
              ...state.billing,
              city: event.target.value,
            },
            dispatch
          );
        }}
      />
    );
  };
  const renderBillingStateInput = () => {
    let error =
      blurList.indexOf("State") > -1 ? stateIssues(state.billing.state) : null;
    return (
      <FormControl
        variant="outlined"
        fullWidth={true}
        error={error ? true : false}
        required
      >
        <InputLabel shrink htmlFor={`state-native-label-placeholder`}>
          State
        </InputLabel>
        <Select
          native
          label="State"
          inputProps={{
            name: "state",
            id: `state-native-label-placeholder`,
          }}
          autoComplete={`billing region`}
          value={state.billing.state}
          onChange={(event) => {
            setBlurList([...blurList, "State"]);
            setBilling(
              {
                ...state.billing,
                state: event.target.value,
              },
              dispatch
            );
          }}
        >
          <option value="SELECT">SELECT</option>
          {consts.STATES.map((state, index) => {
            return (
              <option key={index} value={state.abbreviation}>
                {state.name}
              </option>
            );
          })}
        </Select>
        <FormHelperText>{error ? error : ""}</FormHelperText>
      </FormControl>
    );
  };
  const renderBillingZipInput = () => {
    let error =
      blurList.indexOf("Zip") > -1 ? zipIssues(state.billing.zip) : null;
    return (
      <TextField
        autoComplete="billing postal-code"
        className={classes.input}
        required={true}
        fullWidth={true}
        InputLabelProps={{
          shrink: true,
        }}
        variant="outlined"
        error={error ? true : false}
        helperText={error ? error : ""}
        label="Zip"
        value={state.billing.zip}
        onChange={(event) => {
          setBlurList([...blurList, "Zip"]);
          setBilling(
            {
              ...state.billing,
              zip: event.target.value,
            },
            dispatch
          );
        }}
      />
    );
  };
  const renderBillingCardNumber = () => {
    let error =
      blurList.indexOf("CreditCardNumber") > -1
        ? creditCardNumberIssues(state.billing.cardNumber)
        : null;
    return (
      <InputMask
        mask="9999-9999-9999-9999"
        value={state.billing.cardNumber}
        onChange={(event) => {
          setBlurList([...blurList, "CreditCardNumber"]);
          setBilling(
            {
              ...state.billing,
              cardNumber: event.target.value,
            },
            dispatch
          );
        }}
        disabled={false}
        maskChar=" "
      >
        {() => (
          <TextField
            className={classes.input}
            autoComplete="cc-number"
            name="cardnumber"
            required={true}
            fullWidth={true}
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            error={error ? true : false}
            helperText={error ? error : ""}
            label="Card Number"
          />
        )}
      </InputMask>
    );
  };
  const renderBillingExpiration = () => {
    let error =
      blurList.indexOf("CreditCardExpiration") > -1
        ? creditCardExpirationIssues(state.billing.expiration)
        : null;
    return (
      <InputMask
        mask="99/99"
        value={state.billing.expiration}
        onChange={(event) => {
          setBlurList([...blurList, "CreditCardExpiration"]);
          setBilling(
            {
              ...state.billing,
              expiration: event.target.value,
            },
            dispatch
          );
        }}
        disabled={false}
        maskChar=" "
      >
        {() => (
          <TextField
            className={classes.input}
            autoComplete="cc-exp"
            name="cc-exp"
            required={true}
            fullWidth={true}
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            error={error ? true : false}
            helperText={error ? error : ""}
            label="MM/YY"
          />
        )}
      </InputMask>
    );
  };
  const renderBillingCardCode = () => {
    let error =
      blurList.indexOf("CreditCardCode") > -1
        ? creditCardCodeIssues(state.billing.cardCode)
        : null;
    return (
      <InputMask
        mask="9999"
        value={state.billing.cardCode}
        onChange={(event) => {
          setBlurList([...blurList, "CreditCardCode"]);
          setBilling(
            {
              ...state.billing,
              cardCode: event.target.value,
            },
            dispatch
          );
        }}
        disabled={false}
        maskChar=" "
      >
        {() => (
          <TextField
            className={classes.input}
            autoComplete="cc-csc"
            name="cvc"
            required={true}
            fullWidth={true}
            InputLabelProps={{
              shrink: true,
            }}
            variant="outlined"
            error={error ? true : false}
            helperText={error ? error : ""}
            label="CVC"
          />
        )}
      </InputMask>
    );
  };
  const renderCheckout = () => {
    return (
      <Grid item xs={12}>
        <Stepper
          activeStep={activeStep}
          orientation="vertical"
          nonLinear
          className={classes.stepper}
        >
          {steps.map((step, index) => (
            <Step key={index}>
              <StepButton
                onClick={() => {
                  setActiveStep(index);
                }}
                completed={step.complete}
                className={classes.stepLink}
              >
                <StepLabel error={step.error}>{step.label}</StepLabel>
              </StepButton>

              {step.id == "login" ? (
                <StepContent className={classes.stepContent}>
                  <Grid item container xs={12} spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        {isAuthenticated && user
                          ? "You are logged in as " + user.nickname
                          : "Log in for an easier checkout, to save custom images, and to associate order details with your account."}
                      </Typography>
                    </Grid>
                  </Grid>
                  <div className={classes.commands}>
                    {isAuthenticated ? (
                      <React.Fragment>
                        <Button
                          className={classes.stepButtonSecondary}
                          variant="outlined"
                          color="secondary"
                          onClick={() => {
                            setActiveStep(activeStep + 1);
                          }}
                        >
                          Continue
                        </Button>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <Button
                          className={classes.stepButtonPrimary}
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            // loginWithPopup();
                            loginWithRedirect({
                              appState: {
                                returnTo:
                                  window.location.pathname +
                                  window.location.search,
                              },
                            });
                          }}
                        >
                          Log In
                        </Button>
                        <Button
                          className={classes.stepButtonSecondary}
                          variant="outlined"
                          color="secondary"
                          onClick={() => {
                            setActiveStep(activeStep + 1);
                          }}
                        >
                          Continue as Guest
                        </Button>
                      </React.Fragment>
                    )}
                  </div>
                </StepContent>
              ) : null}
              {step.id == "address" ? (
                <StepContent className={classes.stepContent}>
                  <Grid
                    item
                    container
                    xs={12}
                    spacing={2}
                    className={classes.inputContainer}
                  >
                    <Grid item xs={12} lg={6}>
                      {renderBillingFirstNameInput()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {renderBillingLastNameInput()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {renderBillingCompanyInput()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {renderBillingAddressInput()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {renderBillingCityInput()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {renderBillingZipInput()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {renderBillingStateInput()}
                    </Grid>
                  </Grid>
                  <div className={classes.commands}>
                    <Button
                      className={classes.stepButtonSecondary}
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setActiveStep(activeStep - 1);
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      className={classes.stepButtonPrimary}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        let errors = validateBillingAddress(state.billing);
                        setBlurList([
                          ...blurList,
                          "FirstName",
                          "LastName",
                          "Address",
                          "City",
                          "State",
                          "Zip",
                        ]);
                        if (errors.length == 0) {
                          let updatedSteps = [...steps];
                          updatedSteps[index] = {
                            ...step,
                            complete: true,
                            error: false,
                          };
                          setSteps(updatedSteps);
                          setActiveStep(activeStep + 1);
                        } else {
                          let updatedSteps = [...steps];
                          updatedSteps[index] = {
                            ...step,
                            complete: false,
                            error: true,
                          };
                          setSteps(updatedSteps);
                        }
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </StepContent>
              ) : null}
              {step.id == "payment" ? (
                <StepContent className={classes.stepContent}>
                  <Grid
                    item
                    container
                    xs={12}
                    spacing={2}
                    className={classes.inputContainer}
                  >
                    <Grid item xs={12}>
                      <div className={classes.paymentOptions}>
                        <img
                          src="https://qatisbestdata.blob.core.windows.net/images/mc.png"
                          alt="Mastercard"
                        />
                        <img
                          src="https://qatisbestdata.blob.core.windows.net/images/visa.png"
                          alt="Visa"
                        />
                        <img
                          src="https://qatisbestdata.blob.core.windows.net/images/amex.png"
                          alt="American Express"
                        />
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      {renderBillingCardNumber()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {renderBillingExpiration()}
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      {renderBillingCardCode()}
                    </Grid>
                    <Grid item xs={12}>
                      {renderBusinessUseInput()}
                    </Grid>
                  </Grid>
                  <div className={classes.commands}>
                    <Button
                      className={classes.stepButtonSecondary}
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setActiveStep(activeStep - 1);
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      className={classes.stepButtonPrimary}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        let errors = validateBillingCreditCard(state.billing);
                        setBlurList([
                          ...blurList,
                          "CreditCardNumber",
                          "CreditCardExpiration",
                          "CreditCardCode",
                        ]);
                        if (errors.length == 0) {
                          let updatedSteps = [...steps];
                          updatedSteps[index] = {
                            ...step,
                            complete: true,
                            error: false,
                          };
                          setSteps(updatedSteps);
                          setActiveStep(activeStep + 1);
                        } else {
                          let updatedSteps = [...steps];
                          updatedSteps[index] = {
                            ...step,
                            complete: false,
                            error: true,
                          };
                          setSteps(updatedSteps);
                        }
                      }}
                    >
                      Continue
                    </Button>
                  </div>
                </StepContent>
              ) : null}
              {step.id == "confirm" ? (
                <StepContent className={classes.stepContent}>
                  <Grid
                    item
                    container
                    xs={12}
                    spacing={2}
                    className={classes.inputContainer}
                  >
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        A receipt and all emails detailing gift recipients’
                        charity choices will be sent to this address.
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      {renderBillingEmailInput()}
                    </Grid>
                    <Grid item xs={12}>
                      {renderOptInInput()}
                    </Grid>
                  </Grid>
                  <div className={classes.commands}>
                    <Button
                      className={classes.stepButtonSecondary}
                      variant="outlined"
                      color="secondary"
                      onClick={() => {
                        setActiveStep(activeStep - 1);
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      className={"AcceptUI " + classes.stepButtonPrimary}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        let errors = validateBilling(state.billing);
                        setBlurList([
                          ...blurList,
                          "Email",
                          "FirstName",
                          "LastName",
                          "Address",
                          "City",
                          "State",
                          "Zip",
                          "CreditCardNumber",
                          "CreditCardExpiration",
                          "CreditCardCode",
                        ]);
                        if (errors.length == 0) {
                          setBusy(true, dispatch).then(() => {
                            if (state.quoteid) {
                              getQuoteDetails(state.quoteid).then(
                                (quoteDetails) => {
                                  if (
                                    quoteDetails &&
                                    quoteDetails.transactionID
                                  ) {
                                    setQuoteDetails(
                                      quoteDetails,
                                      dispatch
                                    ).then(() => {
                                      setBusy(false, dispatch);
                                    });
                                  } else {
                                    submitPayment();
                                  }
                                }
                              );
                            } else {
                              submitPayment();
                            }
                          });
                        } else {
                          let addressErrors = validateBillingAddress(
                            state.billing
                          );
                          let creditCardErrors = validateBillingCreditCard(
                            state.billing
                          );
                          let updatedSteps = [...steps];
                          let updatedActiveStep = activeStep;
                          if (creditCardErrors.length > 0) {
                            updatedSteps[2].complete = false;
                            updatedSteps[2].error = true;
                            updatedActiveStep = 2;
                          }
                          if (addressErrors.length > 0) {
                            updatedSteps[1].complete = false;
                            updatedSteps[1].error = true;
                            updatedActiveStep = 1;
                          }
                          setSteps(updatedSteps);
                          setActiveStep(updatedActiveStep);
                        }
                      }}
                    >
                      Purchase
                    </Button>
                  </div>
                </StepContent>
              ) : null}
            </Step>
          ))}
        </Stepper>
      </Grid>
    );
  };

  if (state.quoteDetails && state.quoteDetails.transactionID) {
    return (
      <Accordion square expanded={true}>
        <AccordionSummary>
          <Button
            className={classes.button}
            fullWidth={true}
            variant="contained"
            color="primary"
          >
            Purchase Completed
          </Button>
        </AccordionSummary>
        <AccordionDetails>
          <Typography variant="body1">
            This cart has already been purchased.{" "}
            <Link href={`/order/?orderid=${state.quoteDetails.transactionID}`}>
              View Order Details
            </Link>
          </Typography>
        </AccordionDetails>
      </Accordion>
    );
  } else {
    return (
      <Accordion square expanded={showCheckout}>
        <AccordionSummary>
          <Button
            className={classes.button}
            fullWidth={true}
            variant="contained"
            color="primary"
            onClick={() => {
              if (typeof window !== "undefined") {
                if (window.fbq != null) {
                  window.fbq("track", "initiateCheckout");
                }
              }
              setShowCheckout(true);
            }}
          >
            Checkout
          </Button>
        </AccordionSummary>
        <AccordionDetails>{renderCheckout()}</AccordionDetails>
      </Accordion>
    );
  }
}
